"use client";

import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loading } from "@/components/ui/Spinner";
import { EmptyState } from "@/components/ui/EmptyState";
import { CloudOff } from "lucide-react";
import { EventPage } from "@/components/event/EventPage";
import type { EventDetails } from "@/lib/types/event";

/**
 * The event page when the server could not ask the public API for it: the
 * browser asks instead, and draws the page as soon as it answers.
 */
export function EventPageLoader({ id }: { id: number }) {
  const [event, setEvent] = useState<EventDetails | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    api.get<EventDetails>(`/public-api/event/${id}`, { silent: true }).then((result) => {
      if (!cancelled) {
        setEvent(result ?? null);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (event === undefined) {
    return <Loading className="py-32" />;
  }
  if (event === null) {
    return <EmptyState icon={<CloudOff />} title="Não foi possível carregar o evento" text="Tenta outra vez daqui a um momento." />;
  }
  return <EventPage event={event} />;
}
